export const namespace = 'aggressAttempts'
